import { LanguageSchema } from "@/assets/lang";

const fr: LanguageSchema = {
  "title": "Octopus",
  "button": {
    "cancel": "Annuler",
    "ok": "OK",
    "discardChanges": "Annuler les modifications",
    "search": "Parcourir",
    "confirm": "Confirmer",
    "choose": "Sélectionner",
    "forward": "Suivant",
    "back": "Retour",
    "reset": "Réinitialiser",
    "apply": "Appliquer",
    "login": "S'inscrire",
    "logout": "Se désabonner",
    "send": "Envoyer",
    "backToStart": "Retour à la page d'accueil",
    "backToLogin": "Retour à la connexion",
    "no": "Non",
    "yes": "Oui",
    "toPayment": "Pour le paiement",
    "finishOrder": "Terminer la commande",
    "thank": "Merci beaucoup",
    "sendInvite": "Envoyer l'invitation",
    "resend": "Envoyer à nouveau",
    "startNow": "Démarrer maintenant",
    "skip": "Sauter",
    "register": "S'inscrire maintenant",
    "registerNoCode": "S'inscrire sans code",
    "save": "Enregistrer",
    "saveChanges": "Appliquer les modifications",
    "delete": "{target} supprimer",
    "addCart": "Ajouter la liste au panier",
    "orderNow": "Commander maintenant",
    "add": "Ajouter",
    "changePassword": "Modifier le mot de passe",
    "changeLogin": "Modifier les données de connexion",
    "changeEmail": "Modifier l'email",
    "edit": "Modifier",
    "share": "Partager",
    "delivererNotFound": "Vous n'avez pas trouvé votre fournisseur ?",
    "joinLocation": "Rejoindre une équipe",
    "createLocation": "Créer un lieu",
    "editSupplier": "Fournisseur @.lower:button.edit",
    "create": "Créer",
    "deleteSupplier": "Supprimer un fournisseur",
    "forwardApp": "Continuer vers l'application",
    "endIntro": "Terminer l'introduction",
    "upload": "Télécharger",
    "showMore": "en savoir plus",
    "hide": "cacher",
    "deleteAll": "Supprimer tout",
    "settings": "Préférences",
    "manualSort": "Modifier le tri manuel",
    "switchOldVersion": "Vers l'ancienne version",
    "goToAppVersion": "Utiliser Octopus dans le navigateur",
    "updateList": "Ajouter à la liste",
    "updateCart": "Ajouter au panier",
    "openCameraScanner": "Ouvrir le scanner de l'appareil photo",
    "orderOverview": "Vers l'aperçu des commandes",
    "deleteSupplierCart": "Supprimer le panier",
    "resetAmount": "Réinitialiser les quantités de produits",
    "requestAiCall": "Demander un appel IA",
    "filter": {
      "all": "Tout",
      "promotion": "Actions",
      "productSuggestion": "Inspirations"
    }
  },
  "input": {
    "text": "Texte",
    "password": "Mot de passe | Mots de passe",
    "email": "Email",
    "number": "Numéro",
    "url": "Lien",
    "tel": "Téléphone",
    "search": "Recherche",
    "date": "Date",
    "orderDate": "Date de commande",
    "datetime": "Date",
    "datetime-local": "Heure Heure locale",
    "month": "Mois",
    "week": "Semaine",
    "time": "Heure",
    "range": "Échelle",
    "color": "Couleur"
  },
  "table": {
    "empty": "Tableau ne sélectionne aucun élément"
  },
  "label": {
    "confirm": "confirmer",
    "pwConfirm": "@:input.password @:label.confirm",
    "newReminder": "Ajouter un nouveau réveil de commande",
    "selectPlaceholder": "Sélectionner s'il vous plaît",
    "orderHint": "Note du fournisseur",
    "selectTitle": "Sélectionner",
    "date": "@:input.date",
    "time": "Heure",
    "dateTime": "@:label.date et @:label.time",
    "sum": "Total",
    "orderDetails": "Détails de la facture",
    "promoCode": "Code de bon d'achat",
    "orderNumber": "Numéro de commande",
    "octopusId": "ID de la pieuvre",
    "orderMessage": "Message de commande",
    "description": "Description",
    "sort": "Trier",
    "priceRange": "Gamme de prix",
    "login": "Veuillez vous connecter",
    "user": "Utilisateur",
    "newEmail": "Nouvel email",
    "oldPassword": "Ancien @:input.password",
    "password": "@:input.password",
    "pwForget": "@:input.password oublié",
    "contactData": "Coordonnées de contact",
    "name": "Nom",
    "list": "Liste",
    "type": "Type",
    "zip": "CODE POSTAL",
    "city": "Ville",
    "street": "Adresse",
    "streetNumber": "Numéro de la maison",
    "phone": "Téléphone",
    "fax": "Fax",
    "streetName": "Nom de la rue",
    "postalCode": "@:label.zip",
    "deliverer": "@:object.deliverer",
    "customerNumber": "Numéro de client/numéro d'établissement",
    "quickstart": "Code de démarrage rapide",
    "email": "@:input.email",
    "firstName": "Prénom",
    "lastName": "Nom",
    "dark": "Sombre",
    "light": "Clair",
    "standard": "Réglage du système",
    "amount": "Quantité",
    "multipleAmount": "La quantité doit être un multiple de {target}.",
    "maxAmount": "Maximum {target} article",
    "standardList": "Liste standard",
    "language": "Langue",
    "aiCallLanguage": "Langue d'appel",
    "oldMessages": "Anciennes nouvelles",
    "notification": {
      "allow": "Autoriser les communications"
    },
    "permission": {
      "order": "@:object.order",
      "promotion": "@:object.promotion",
      "message": "@:object.message",
      "news": "Nouvelles",
      "reminder": "Rappel de commande",
      "productPromotion": "Suggestions de produits",
      "sub": {
        "newOrder": "Nouvelles commandes",
        "updateStatus": "Mise à jour des commandes",
        "added": "Nouvelle promotion",
        "ending": "Promotion le",
        "general": "Généralités"
      },
      "mode": {
        "push": "Message push",
        "email": "Notification par e-mail",
        "popup": "Popup"
      }
    },
    "teamRole": {
      "admin": "Admin",
      "user": "Membre de l'équipe Pro",
      "device": "Membre de l'équipe Base",
      "OWNER": "Propriétaire"
    },
    "teamRoleShort": {
      "admin": "Admin",
      "user": "Pro",
      "device": "Base",
      "OWNER": "Propriétaire"
    },
    "support": {
      "general": "Support Octopus",
      "gastro": "Équipe Service client Gastro",
      "technical": "Équipe Service client technique",
      "technicalLead": "Leader technique",
      "distribution": "Fondé de pouvoir, Marketing, Ventes",
      "service": "Équipe service client"
    },
    "loading": {
      "location": "Charge @:object.location"
    },
    "onAccount": "Facture",
    "onAccountOrCash": "Facture ou espèces",
    "ON_ACCOUNT": "@:label.onAccount",
    "UNSPECIFIED": "non indiqué",
    "CASH": "@:label.cash",
    "cash": "Bar",
    "bar": "Bar / pub",
    "office": "Bureau",
    "coffeeShop": "Café / Bistro",
    "caterer": "Traiteur / Cantine / Associations",
    "club": "Club / discothèque",
    "EVENT": "Événement",
    "DEALER": "Marchand",
    "takeAway": "Snack-bar / kiosque / take-away",
    "canteen": "Cantine",
    "restaurant": "Restaurant",
    "hotel": "Hôtel",
    "spaetshop": "Station-service / magasin de fin de journée",
    "getraenkehaendler": "Distributeur de boissons",
    "getraenkeabholmarkt": "Vente de boissons à emporter",
    "STAR_GASTRONOMY": "Gastronomie étoilée",
    "SYSTEM_GASTRONOMY": "Restauration collective",
    "spaetShop": "Boutique de fin de journée",
    "impress": "Mentions légales",
    "termsOfUse": "Conditions d'utilisation",
    "agreeAGB1": "J'accepte les",
    "agreeAGB2": "Politique de confidentialité",
    "agreeAGB3": "à",
    "category": "Catégorie",
    "noCategory": "Sans catégorie",
    "editTags": "Créer ses propres catégories",
    "selectDeliverer": "Sélectionner @:object.deliverer",
    "threeChars": "Saisir au moins trois caractères pour obtenir des résultats de recherche",
    "offlineMode": "Mode hors ligne",
    "disable": "désactiver",
    "enable": "activer",
    "at": "sur",
    "atTime": "à",
    "and": "et",
    "customerNo": "Numéro de client",
    "current": "Actuel",
    "tags": "Catégories de filtres",
    "ownCategories": "Propres catégories",
    "supplierCategories": "Catégories de fournisseurs",
    "noFilter": "Pas de filtre",
    "quantity": "Quantité",
    "quantityBiggerZero": "Avec quantité",
    "or": "ou",
    "delivererType": {
      "online": "En ligne",
      "offline": "Hors ligne"
    },
    "deleted": "Supprimé",
    "resetAmount": "Réinitialiser la quantité de produits après la commande",
    "compatibilityMode": "Mode de compatibilité",
    "timeIssueDelivery": "La date de livraison que tu as indiquée se situe dans le passé. Veuillez choisir une date ultérieure.",
    "timeIssuePickup": "La date d'enlèvement que tu as indiquée se situe dans le passé. Veuillez choisir une date ultérieure.",
    "wait": "Veuillez attendre",
    "day": "Tag",
    "month": "Mois",
    "all": "Tous",
    "articleNo": "N° d'article",
    "targetStock": "Quantité théorique",
    "targetStockShort": "Consigne",
    "resetProductQuantity": "En activant le curseur, la quantité de produits est remise à zéro après le transfert réussi de ta commande. Si tu ne l'actives pas, la quantité de produits reste pré-remplie pour le prochain traitement de ta liste.",
    "offlineMode1": "Le mode hors ligne te donne la possibilité de synchroniser ta liste et de la gérer ensuite même sans connexion Internet.",
    "offlineMode2": "Lorsque tu quittes le mode hors ligne, toutes les modifications sont synchronisées avec le serveur.",
    "darkMode": "Mode sombre",
    "compatibilityText": {
      "activate": "Active ce mode si tu souhaites modifier les quantités de produits de ta liste dans l'application, mais que tu passes ta commande via le portail web.",
      "webPortal": "Tant que ce mode est activé, la quantité de la liste est synchronisée avec le portail web et il n'est pas possible de commander cette liste via l'app.",
      "deactivate": "Désactive ce mode si tu veux commander via l'application."
    },
    "newProductSuggestion": "Nouvelle proposition de produit",
    "files": "Fichiers",
    "issue": "Problème",
    "place": "Lieu",
    "expectation": "Attente",
    "steps": "Étapes",
    "availability": "Disponibilité",
    "availableFrom": "Disponible sur",
    "deletedLocations": "Lieux supprimés",
    "reducedListDesign": "Design de liste réduit",
    "reducedListDesignDescription": "Le design de liste réduit modifie l'affichage de ta liste. Les images des produits sont masquées, mais des boutons supplémentaires sont affichés pour l'utilisation.",
    "insert": "insérer",
    "camera": "Appareil photo",
    "scanner": "Scanner",
    "picture": {
      "takePicture": "Prendre une photo",
      "selectPicture": "Sélectionner une image",
      "editPicture": "Modifier l'image",
      "removePicture": "Supprimer l'image"
    },
    "uncategorized": "Non classé",
    "orderDataLoading": "Les données de commande sont chargées.",
    "screenshot": "Capture d'écran",
    "uploadImage": "Télécharger une image",
    "aiCallbackPhone": "Enregistrer un numéro de téléphone pour être rappelé"
  },
  "error": {
    "addReminder": "Réveil de commande n'a pas pu être attribué à une liste",
    "noMatch": "{target} ne correspond pas",
    "notFound": "{target} n'a pas été trouvé. | {target} n'ont pas été trouvés.",
    "invalid": "{target} n'est pas correct. | {target} ne sont pas corrects.",
    "empty": "{target} est vide. | {target} sont vides.",
    "noAuth": "{target} n'a pas d'autorisation. | {target} n'ont pas d'autorisation.",
    "noAdmin": "Aucune autorisation d'admin n'a été trouvée.",
    "addCart": "Le produit n'a pas pu être ajouté au panier. | Les produits n'ont pas pu être ajoutés au panier.",
    "addPromoPackage": "Le paquet promotionnel n'a pas été ajouté au panier ou n'a été ajouté que partiellement.",
    "addList": "Le produit n'a pas pu être ajouté à la liste. | Les produits n'ont pas pu être ajoutés à la liste.",
    "create": "{target} n'a pas pu être créé. | {target} n'a pas pu être créé.",
    "order": "La commande n'a pas pu être exécutée.",
    "save": "{target} n'a pas pu être enregistré.",
    "delete": "{target} n'a pas pu être supprimé.",
    "deleteUser": "L'utilisateur n'a pas pu être supprimé.",
    "resendMail": "L'email n'a pas pu être réenvoyé.",
    "sendLink": "Le lien n'a pas pu être envoyé.",
    "removeProduct": "Le produit n'a pas pu être retiré du panier. | Les produits n'ont pas pu être supprimés du panier.",
    "registerFalse": "Échec de l'enregistrement.",
    "loginFalse": "Echec de la connexion.",
    "locationFalse": "Échec de la création de l'emplacement.",
    "orderFinish": "La commande n'a pas pu être créée.",
    "send": "{target} n'a pas pu être envoyé.",
    "loadSupplier": "Le fournisseur n'a pas pu être chargé | Les fournisseurs n'ont pas pu être chargés.",
    "loadLists": "Les listes n'ont pas pu être chargées.",
    "load": "{target} n'a pas pu être chargé. | {target} n'a pas pu être chargé.",
    "sendTicket": "Le feedback n'a pas pu être envoyé.",
    "scanBarcode": "Le code-barres scanné n'est pas valide.",
    "promotionLimitReached": "Le nombre max. Quantité d'action atteinte",
    "aiCall": "@:error.returnType.Unknown",
    "ajv": {
      "required": "Les champs obligatoires ne sont pas remplis",
      "format": "La saisie n'était pas correcte : la saisie devrait être au format {formatInfo}.",
      "formatInfo": {
        "date": "Date",
        "time": "Heure",
        "email": "Email",
        "date-time": "Date & ; Heure"
      },
      "oneOf": "L'entrée ne correspond à aucune des valeurs possibles",
      "minimum": "L'entrée est inférieure au minimum de {min}",
      "maximum": "L'entrée dépasse le maximum de {max}.",
      "enum": "L'entrée ne contient pas l'une des valeurs possibles"
    },
    "returnType": {
      "Unknown": "Une erreur s'est produite",
      "BadRequest": "La demande contient des données erronées",
      "NotFound": "La demande n'a pas trouvé d'élément.",
      "Unauthorized": "Autorisation manquante",
      "Forbidden": "La demande n'est pas autorisée",
      "NotImplemented": "La demande n'est pas implémentée",
      "InvalidLogin": "Login non valide",
      "InvalidSession": "Session non valide",
      "InvalidPassword": "Mot de passe non valide",
      "UserNotFound": "Utilisateur introuvable",
      "UserAlreadyExists": "L'utilisateur existe déjà",
      "UserEmailAlreadyExists": "Il existe déjà un utilisateur avec cet email",
      "LocationNotFound": "Emplacement non trouvé",
      "CartItemNotFound": "Produit non trouvé",
      "ItemAlreadyInCart": "Le produit est déjà dans le panier, modifiez votre sélection dans le panier.",
      "ListAlreadyInCart": "La liste est déjà dans le panier, modifie ta sélection dans le panier. La liste ne peut être éditée qu'une fois que la liste a été commandée dans le panier.",
      "ListCantBeDeleted": "La liste ne peut pas être supprimée.",
      "ListEmpty": "La liste est vide. Vérifie si au moins un produit a une quantité supérieure à 0.",
      "SupplierNotFound": "Fournisseur introuvable",
      "SupplierItemNotFound": "Produit fournisseur non trouvé",
      "OrderNotFound": "Commande non trouvée",
      "ListNotFound": "Liste non trouvée",
      "ListItemNotFound": "Produit de la liste non trouvé",
      "ItemAlreadyInList": "Le produit est déjà dans la liste, modifie ta sélection dans la liste",
      "ItemNotFromListSupplier": "Le produit n'est pas du fournisseur de cette liste",
      "NotificationNotFound": "Notification non trouvée",
      "TagNotFound": "Catégorie non trouvée",
      "TagAlreadyExists": "La catégorie existe déjà",
      "UserNotInTeam": "Cet utilisateur ne fait pas partie de l'équipe",
      "TokenInvalid": "Le code saisi n'est pas valide",
      "ReminderNotFound": "Le rappel de commande n'a pas été trouvé",
      "OwnerCantBeEdited": "Le propriétaire ne peut pas être édité",
      "PromoCodeInvalid": "Le code du bon n'est pas valable",
      "PromoCodeInvalidAlreadyExists": "Le code du bon a déjà été utilisé",
      "QuickStartCodeInvalid": "Le code Quickstart n'est pas valide",
      "SupplierAlreadyExists": "Le fournisseur existe déjà",
      "SupplierCustomerInvalid": "Le fournisseur de localisation n'est pas valide",
      "LocationAlreadyExists": "Le lieu existe déjà",
      "JavaApiInternalServerError": "Une erreur est survenue",
      "NewsNotFound": "Message non trouvé",
      "OrderMessageTooLong": "Le message de commande dépasse la longueur maximale",
      "EmailInvalid": "L'email n'est pas valide",
      "TokenInvalidAlreadyUsed": "Le code saisi a déjà été utilisé",
      "SupplierBlocked": "Le fournisseur est bloqué",
      "PromotionExpired": "Articles en promotion expirés"
    },
    "scannedProductNotAvailable": "Le produit scanné n'est pas disponible dans le catalogue de votre fournisseur, il ne peut donc pas être ajouté à la liste des scanners.",
    "scannerNotAvailable": "Aucun scanner n'est connecté à ton appareil. Veuillez vous connecter à un scanner ou vérifier votre connexion existante"
  },
  "error.": "Une erreur s'est produite",
  "target": {
    "username": "Nom d'utilisateur",
    "user": "Utilisateur",
    "userAndPw": "@:target.username et @:input.password",
    "setting": "Réglage | Paramètres",
    "profile": "Profil",
    "location": "Lieu",
    "order": {
      "paypal": "PayPal"
    },
    "product": "Produit | Produits",
    "request": "Demande de renseignements",
    "list": "Liste",
    "required": "Champ obligatoire | Champs obligatoires",
    "field": "champ | champs",
    "deliverer": "Fournisseur | Fournisseurs",
    "tag": "Catégorie | Catégories",
    "password": "Mot de passe",
    "permission": "Autorisation | Autorisations"
  },
  "messages": {
    "orderFrom": "Commande auprès de",
    "mobileWeb": "Nous avons remarqué que tu essaies d'ouvrir la version web d'Octopus Order depuis un appareil mobile. Pour une meilleure expérience utilisateur, nous te conseillons, sur les appareils mobiles, de télécharger l'application mobile depuis ton App-Store et de l'utiliser à la place de la version web.",
    "mobileWeb2": "Les liens suivants te permettront d'accéder à l'application mobile Octopus Order :",
    "setting": {
      "location": "Modifier ton lieu",
      "profile": "Modifier ton profil d'utilisateur",
      "delivererAssign": "Attribuer un fournisseur à ton lieu",
      "delivererSelect": "Sélectionner un fournisseur",
      "inputCustomerNr": "Inscrire le numéro de client",
      "changeLocation": "Changer de lieu",
      "welcome1": "Bonjour {name}",
      "welcome2": "Ici, tu peux choisir",
      "welcome3": "quelle présentation tu préfères"
    },
    "emptyCart": "Malheureusement, ton panier est vide.",
    "emptySuggestion": "Malheureusement, nous n'avons actuellement aucune proposition de produit pour toi.",
    "card": {
      "forwardPoints": "Clique ici pour être redirigé vers notre @:object.pointSystem",
      "points": "Points Octopus",
      "shop": "Vers la boutique Octopus",
      "currentPromotion": "Promotions actuelles",
      "createLocationExplanation": "Un lieu peut être un bar, un restaurant, un hôtel, un bureau ou un commerce similaire.",
      "productSuggestion": "Nouveautés et propositions de produits"
    },
    "noPromotion": "En ce moment, nous n'avons malheureusement pas d'action pour toi.",
    "promotion": {
      "order": "Peut être commandé chez",
      "octopus": "Promotions Octopus",
      "deliverer": "Promotions de tes fournisseurs",
      "articles": "Ces articles ont actuellement un prix promotionnel"
    },
    "home": {
      "createLocation": "Nouveau @:messages.location.create",
      "welcome1": "Bonjour {name}",
      "welcome2": "de quel lieu s'agit-il ?",
      "image1": "Mélangé, tiré, commandé !",
      "image2": "Sûr, numérique, commande !",
      "image3": "Simple, rapide, livrer !"
    },
    "dashboard": {
      "catalog": {
        "availableProduct": "Tous les articles disponibles",
        "delivererCatalog": "Assortiment du fournisseur",
        "createProduct": "Ajouter un produit",
        "createdCustomProduct": "Le produit a été ajouté à la liste.",
        "noReducedSupplier": "Actuellement, aucun de tes fournisseurs ne propose d'offres."
      },
      "home": {
        "orders": "Vos dernières commandes",
        "favouriteList": "Tes dernières listes commandées",
        "news": "Nouvelles d'Octopus"
      },
      "list": {
        "allLists": "Toutes les listes de ce lieu",
        "createList": "Nouvelle @:titleRoute.addList",
        "noSupplier": "Tu n'as pas encore ajouté de fournisseur à ton lieu. Veuillez ajouter un fournisseur via les paramètres."
      },
      "message": {
        "available": "Nouvelles disponibles"
      },
      "setting": {
        "order": "Tout ce qui concerne tes commandes en un coup d'œil",
        "team": "Aperçu et gestion de ton équipe",
        "deliverer": "Ici tu peux voir tes fournisseurs",
        "notification": "Gère ici tes notifications",
        "display": "Choisis entre le mode sombre ou lumineux",
        "statistic": "Ici tu peux voir tes évaluations",
        "imprint": "Informations et aspects juridiques",
        "support": "Prendre contact avec Octopus Order",
        "orderNotificationTimer": "Régler ton réveil de commande",
        "intro": "Découvre toutes les fonctions de l'application"
      }
    },
    "location": {
      "thank": "@:bouton.thank",
      "sendMsg": "Envoyer un message",
      "create": "Ajouter un lieu",
      "requestSent": "Ta demande au fournisseur {deliverer} est en cours d'examen. Un collaborateur te contactera dans les prochains jours.",
      "assignDeliverer": "Attribue un fournisseur à ton lieu",
      "welcome1": "Bonjour {name}",
      "intro": "En 4 courtes étapes, nous complétons ensemble ton profil"
    },
    "noOrders": "Tu n'as pas encore passé de commande.",
    "noOrdersFilter": "Tu n'as pas passé de commande pendant cette période.",
    "noLists": "Tu n'as pas encore créé de listes.",
    "noNotifications": "Tu n'as pas encore reçu de notifications.",
    "noNews": "Désolé, il n'y a actuellement aucune actualité Octopus.",
    "order": {
      "deliveryType": "Choisir le mode de livraison",
      "deliveryTime": "Choisir le jour de livraison",
      "pickupTime": "Sélectionner l'heure d'enlèvement",
      "pickup": "Enlèvement",
      "delivery": "Livraison",
      "overview": "Aperçu des commandes",
      "choosePayment": "Choisir le mode de paiement",
      "redirectPayment": "Dans l'étape suivante, tu seras redirigé vers {target}.",
      "rememberPayment": "Utiliser le mode de paiement pour les futures commandes.",
      "voucher": "Bon d'achat | Bons d'achat",
      "redeemVoucher": "@:messages.order.voucher à utiliser",
      "voucherCode": "Saisir le code du bon",
      "currentOrders": "Mes commandes",
      "orderProducts": "Vos commandes @:object.article",
      "otherProducts": "Autres articles fréquemment commandés",
      "sent": "Votre commande a été transmise avec succès à {target}.",
      "locationIssue": "Lieu de collecte manquant. Veuillez indiquer un lieu de collecte."
    },
    "deliverer": {
      "allDeliverers": "Tous les @:object.deliverer de {location}",
      "addDeliverer": "Ajouter un @:object.deliverer",
      "noEmail": "Veuillez ajouter une adresse e-mail au fournisseur avant de pouvoir commander"
    },
    "team": {
      "invite": {
        "welcome1": "@:messages.home.welcome1",
        "welcome2": "Invite d'autres collaborateurs ou partenaires à l'application...",
        "copy": "Ou copie simplement le code et partage-le :",
        "messenger": "Invite directement via la messagerie de ton choix :",
        "mail": "Par adresse e-mail",
        "joinTeam": "Rejoins notre équipe",
        "joinTeam2": "Tu as été invité au lieu {location} dans l'application Octopus Order !\n\nAvec ce lien, tu peux directement rejoindre ton équipe.\n\n{inviteLink}\n\nSi cela ne fonctionne pas, tu peux aller dans l'application avec le code\n\n{link}\n\npour rejoindre ta nouvelle équipe.\n\nPour Android : {appLinkAndroid}\n\nPour IOS : {appLinkIOS}",
        "shareHint": "Pour des raisons de sécurité, le code généré/envoyé ne peut inviter que des utilisateurs de base. Pour une invitation avec les droits sélectionnés, veuillez utiliser l'invitation par e-mail."
      },
      "management": {
        "members": "Membres de l'équipe de {location}",
        "inviteMember": "Inviter des membres de l'équipe",
        "addDevice": "Ajouter un appareil",
        "permissionExplanation": "Aperçu des droits de nos rôles :"
      }
    },
    "missingPermission": "Autorisation manquante : {permission}",
    "missingCartOrderPermission": "Tes autorisations dans l'application ne sont pas suffisantes. Veuillez contacter le propriétaire de votre lieu pour passer une commande.",
    "permission": {
      "all": "Tous les droits",
      "locationOrderHistoryRead": "Lire l'historique des commandes",
      "locationListRead": "Consulter les listes",
      "locationListItemRead": "Consulter les produits de la liste",
      "locationListItemCreate": "Créer des produits de liste",
      "locationListItemUpdate": "Modifier les produits de liste",
      "locationListItemDelete": "Supprimer des produits de liste",
      "locationListCreate": "Créer des listes",
      "locationListUpdate": "Modifier les listes",
      "locationListDelete": "Supprimer des listes",
      "locationCartRead": "Consulter le panier",
      "locationCartAdd": "Remplir le panier",
      "locationCartUpdate": "Modifier les produits du panier",
      "locationCartDelete": "Supprimer des produits du panier",
      "locationOrderCreate": "Créer une commande",
      "locationOrderRequest": "Exécuter une demande de commande",
      "locationRead": "Consulter le lieu",
      "locationCreate": "Créer un lieu",
      "locationUpdate": "Modifier un lieu",
      "locationDelete": "Supprimer un lieu",
      "locationTeamRead": "Voir l'équipe",
      "locationTeamMemberAdd": "Ajouter un membre de l'équipe",
      "locationTeamMemberDelete": "Supprimer un membre de l'équipe",
      "locationTeamMemberRoleUpdate": "Modifier les rôles des membres de l'équipe",
      "locationSupplierRead": "Consulter les fournisseurs",
      "locationSupplierCreate": "Ajouter des fournisseurs",
      "meRead": "Lire ses propres données d'utilisateur",
      "meUpdate": "Modifier ses propres données d'utilisateur",
      "meDelete": "Supprimer son propre utilisateur",
      "locationListReminderCreate": "Créer un réveil de commande",
      "locationListReminderDelete": "Effacer le réveil de commande",
      "locationListReminderRead": "Consulter les alertes de commande",
      "locationListReminderUpdate": "Modifier le rappel de commande",
      "locationContactSupplier": "Contacter le fournisseur"
    },
    "noListEntries": "Actuellement, il n'y a pas encore d'articles dans cette liste.",
    "noSearchResults": "Aucun article n'a été trouvé pour ton filtre",
    "noEntries": "Aucun élément n'est disponible",
    "noMail": "Pas reçu de mail",
    "login": {
      "emailSent": "Nous venons de t'envoyer un email",
      "setPassword": "En cliquant sur le lien, tu peux définir un nouveau mot de passe",
      "resetPassword": "Saisis ton adresse e-mail et reçois un nouveau mot de passe"
    },
    "start": {
      "notNew": "Déjà client",
      "new": "Ici pour la première fois"
    },
    "cart": {
      "amount": "{amount} positions d'articles",
      "selectionFrom": "Sélection chez {deliverer}",
      "fromList": "A partir de vos listes",
      "noList": "Sans liste",
      "lastOrder": "De ta dernière commande",
      "amountItems": "{amount} article unique",
      "upgradeToPromotion": "On y est presque ! Il ne reste plus que {amount} Pièces jusqu'à la {shortTitle} Action 🏷️ → commander maintenant",
      "convertToPromotion": "Action sauvegardée 🏷️ → activer maintenant"
    },
    "register": {
      "intro": "Pour créer ton profil, nous avons besoin de quelques informations",
      "thank": "Merci {name}",
      "emailSent": "@:messages.login.emailSent",
      "validate": "Veuillez confirmer votre compte en cliquant sur le lien",
      "validateEmail": "@:{'messages.register.validate'} qui a été envoyé à ton adresse e-mail avant que tu puisses commander",
      "noCode": "Je n'ai pas de code d'invitation",
      "code": "J'ai reçu un code d'invitation",
      "skipEmail": "Désolé, nous n'avons pas trouvé l'adresse e-mail que tu as saisie. Veuillez confirmer à nouveau votre adresse e-mail."
    },
    "didYouMean": "Tu cherches peut-être {target} ?",
    "didYouCheck": "As-tu déjà recherché tous les fournisseurs dans la vue précédente ?",
    "agbRequired": "La disposition relative à la protection des données doit être acceptée.",
    "list": {
      "repeatEach1": "Rappel",
      "repeatEach2": "Tous",
      "noTags": "Aucune catégorie de filtre disponible. Ajoutez des catégories à vos produits de liste.",
      "overrideCartList": "La liste se trouve déjà dans le panier. Tu veux écraser ton panier ?",
      "overrideProductList": "Ce produit se trouve déjà dans le panier. Tu veux écraser ton panier ?",
      "noReminder": "Aucun réveil de commande n'a encore été créé pour cette liste.",
      "amountReset": "Les quantités de produits ont été réinitialisées.",
      "resetCheck": "Es-tu sûr de vouloir remettre à 0 toutes les quantités de cette liste ?"
    },
    "pressEnter": "Confirmez sur le clavier pour ajouter",
    "changedEmail": "Nous venons de t'envoyer un e-mail à la nouvelle adresse. Pour appliquer la modification, clique sur le lien qui t'a été envoyé.",
    "updateLoading": "Mise à jour en cours d'installation",
    "intro": {
      "home": {
        "msg1": "L'en-tête te permet de revenir à l'aperçu de tes lieux et à ton panier d'achat.",
        "title1": "Accéder à tes lieux et au panier d'achat",
        "msg2": "Tu peux accéder à tes dernières commandes et aux listes de produits fréquemment commandés directement via le tableau de bord.",
        "title2": "Aperçu de tes activités",
        "msg3": "La barre de menu te permet d'atteindre ta destination en un seul clic.",
        "title3": "Navigation accessible partout"
      },
      "list": {
        "title1": "C'est ici que commence la commande",
        "msg1": "L'en-tête te permet d'accéder à tes listes et au catalogue. Ici, tu peux parcourir les articles de tes fournisseurs.",
        "title2": "Tes fournisseurs",
        "msg2": "Ici, tu peux consulter et modifier les listes de commande de tes fournisseurs ou créer toi-même de nouvelles listes.",
        "title3": "Trier et supprimer",
        "msg3": "Appuyez sur l'image du produit pour sélectionner un ou plusieurs articles, les déplacer par glisser-déposer ou les supprimer à l'aide de l'icône de la corbeille.",
        "title4": "Personnaliser facilement la liste",
        "msg4": "La quantité d'un produit peut être modifiée à l'aide des boutons plus et moins. Balayez vers la droite pour supprimer le produit de la liste.",
        "title5": "Trouver rapidement un article",
        "msg5": "Dans le catalogue, tu peux voir les différents articles de tes fournisseurs, les parcourir et les filtrer par catégorie."
      },
      "promotion": {
        "title1": "Actions et suggestions",
        "msg1": "Ici, tu peux voir les actions actuelles, les propositions de produits ou les nouvelles de tes fournisseurs ou d'Octopus Order.",
        "title2": "Offres promotionnelles de tes fournisseurs",
        "msg2": "Ici, tu peux voir les articles de tes fournisseurs pour lesquels des actions spéciales sont actuellement disponibles.",
        "title3": "Propositions et actualités actuelles",
        "msg3": "Avec les propositions de produits, tu reçois des informations sur les dernières tendances de la branche des boissons. Dans les News, tu découvriras toutes les nouveautés concernant Octopus."
      },
      "setting": {
        "msg1": "Ici, tu peux gérer tes fournisseurs et ton emplacement, effectuer des réglages, consulter tes commandes ou contacter le support.",
        "title1": "Réglages de l'app",
        "msg2": "Tu peux régler ici des alarmes qui te rappellent régulièrement de commander ta liste.",
        "title2": "Ne plus oublier de commande",
        "msg3": "Tu peux y gérer ton équipe et inviter d'autres membres de l'équipe à Octopus Order.",
        "title3": "Ta propre équipe",
        "msg4": "Ici, tu as un aperçu de tous tes fournisseurs et tu peux les modifier ou les supprimer ainsi qu'ajouter de nouveaux fournisseurs.",
        "title4": "Aperçu des fournisseurs"
      }
    },
    "ordering": "Commande en cours d'exécution",
    "noConnection1": "Pas de connexion au serveur",
    "noConnection2": "Veuillez vérifier votre connexion Internet",
    "switchLocation": "La notification appartient à un autre lieu. Tu veux changer de lieu ?",
    "containsExpiredPromotion": "Ton panier contient un article en promotion qui a expiré. Veuillez l'enlever pour continuer votre commande.",
    "addProductsViaScanner": "Ajouter des produits via un scanner",
    "scanDesiredProducts": "Scanne les produits que tu souhaites",
    "scanToAddMoreProducts": "Scanner pour ajouter d'autres produits",
    "updateScanItems": "Tu veux ajouter tes articles scannés à ta liste ? Le nombre d'articles dans la liste sera écrasé.",
    "addScanItems": "Veux-tu ajouter tes articles scannés au panier ?",
    "holidayDeliveryTitle": "Le jour de livraison choisi est un jour férié !",
    "holidayDelivery": "Veuillez vous renseigner sur votre date de livraison exacte auprès de votre fournisseur.",
    "longOrder": "Votre commande se situe à plus de sept jours dans le futur. Voulez-vous vraiment commander à {date} ?",
    "cartDataMissing": "Données de commande erronées",
    "newBinaryVersion": "Une nouvelle version est disponible et contient des modifications importantes. Veuillez mettre à jour votre version.",
    "deliveryDayWarningTitle": "La date choisie n'est pas un jour de livraison régulier !",
    "deliveryDayWarning": "Veuillez clarifier les cas exceptionnels au préalable avec le fournisseur.",
    "holidayPickupTitle": "Le jour de collecte choisi est un jour férié !",
    "holidayPickup": "Veuillez vous renseigner auprès de votre fournisseur pour connaître la date exacte de votre enlèvement.",
    "modal": {
      "updateLocationTypeTitle": "Ton choix, ton avantage",
      "updateLocationTypeDescription": "En choisissant ton établissement de restauration, nous adaptons les contenus et les actions pour toi. Tu peux modifier ce paramètre à tout moment.",
      "updateLocationTypeHint": "La sélection n'est utilisée qu'au sein de l'application et peut être adaptée à tout moment."
    },
    "currentLocation": "Tu es actuellement dans le lieu"
  },
  "object": {
    "order": "Commande | Commandes",
    "article": "Positions des articles",
    "promotion": "Action | Actions",
    "location": "Emplacement",
    "cart": "Panier d'achat",
    "list": "Liste | Listes",
    "filter": "Filtre",
    "message": "message | nouvelles",
    "catalog": "Catalogue",
    "notification": "Notification | Notifications",
    "notificationOption": "@:object.notification{'sooptions'}",
    "setting": "Préférences",
    "intro": "Apptour",
    "home": "Accueil",
    "dark": "Sombre",
    "light": "Clair",
    "zip": "CODE POSTAL",
    "city": "Lieu",
    "street": "Rue",
    "lastname": "Nom",
    "firstname": "Prénom",
    "address": "Adresse",
    "zipCity": "@objet:zip, @objet:ville",
    "profile": "Profil",
    "pointSystem": "Système de points",
    "amount": "Quantité",
    "price": "Prix unitaire",
    "total": "Prix total",
    "notAvailable": "Information sur le prix non disponible",
    "sort": "Trier",
    "alphabetic": "Par ordre alphabétique",
    "filterCategory": "@:object.filter{'catégorie'}",
    "priceRange": "Gamme de prix",
    "team": "Équipe",
    "deliverer": "Fournisseur | Fournisseurs",
    "display": "Options de présentation",
    "statistic": "Statistiques",
    "imprint": "Mentions légales",
    "law": "Mentions légales",
    "support": "Support de commande Octopus",
    "filterOption": {
      "spirits": "Spiritueux",
      "nonAlcoholic": "Boissons sans alcool",
      "beer": "Bière",
      "gastro": "Besoins gastro",
      "wine": "Vin",
      "food": "Alimentation",
      "nonFood": "Non alimentaire",
      "other": "Autres"
    },
    "suggestion": "Produit{hyphen}proposition | Produit{hyphen}propositions",
    "news": "Actualités",
    "days": "jours | jour",
    "hours": "heures | heure",
    "minutes": "minutes | minute",
    "validFor": "Valable pour {value}",
    "validUntil": "Valable jusqu'au",
    "expired": "Expiré",
    "totalPosition": "Total Poste",
    "totalOrder": "Valeur totale de la commande"
  },
  "enumT": {
    "pinned": "Attaché",
    "new": "Nouveau",
    "restocked": "De nouveau disponible",
    "reduced": "En offre",
    "notInStock": "Avec délai de livraison",
    "promotion": "Articles en promotion",
    "issueType": {
      "bug": "Bug",
      "feature": "Fonctionnalité"
    },
    "contactWay": {
      "none": "Ne pas contacter",
      "email": "Email",
      "phone": "Téléphone",
      "emailOrPhone": "Email ou téléphone"
    },
    "sortDirection": {
      "asc": "Croissant Alphabétique",
      "desc": "Décroissant Alphabétique",
      "catFilter": "Par catégorie personnelle",
      "catSupplier": "Par catégorie de fournisseurs",
      "manually": "Tri manuel"
    },
    "weekday": {
      "mon": "Lundi",
      "tue": "Mardi",
      "wed": "Mercredi",
      "thu": "Jeudi",
      "fri": "Vendredi",
      "sat": "Samedi",
      "sun": "Dimanche"
    },
    "repeatCycle": {
      "once": "une fois",
      "week": "hebdomadaire",
      "month": "mensuel",
      "appendix": {
        "week": "semaine(s)",
        "month": "mois(s)"
      }
    },
    "month": {
      "january": "Janvier",
      "february": "Février",
      "march": "Mars",
      "april": "Avril",
      "may": "Mai",
      "june": "Juin",
      "july": "Juillet",
      "august": "Août",
      "september": "Septembre",
      "october": "Octobre",
      "november": "Novembre",
      "december": "Décembre"
    }
  },
  "modal": {
    "selection": "Choix possibles",
    "addList": "Ajouter à la liste",
    "addCart": "Ajouter au panier",
    "openCatalog": "Ouvrir dans le catalogue"
  },
  "success": {
    "addReminder": "Le réveil de commande a été ajouté",
    "editReminder": "Réveil de commande enregistré",
    "deleteReminder": "Le réveil de commande a été supprimé",
    "addCart": "Le produit a été ajouté au panier. | produits ont été ajoutés au panier",
    "addPromoPackage": "Pack promotionnel a été ajouté au panier.",
    "addCartNumber": "{target} Les articles de {target2} ont été ajoutés au panier.",
    "addList": "Le produit a été ajouté à la liste. | Les produits ont été ajoutés à la liste.",
    "order": "La liste a été commandée.",
    "save": "{target} a été enregistré avec succès. | {target} ont été sauvegardés avec succès.",
    "resendMail": "Le courriel a été envoyé à nouveau.",
    "copyLink": "Le lien a été copié",
    "sendLink": "Le lien a été envoyé.",
    "removeProduct": "Le produit a été retiré du panier. | produits ont été retirés du panier.",
    "orderFinish": "La commande a été créée.",
    "delete": "{target} a été supprimé.",
    "deleteUser": "L'utilisateur a été supprimé",
    "deleteMulti": "{amount} {target} ont été supprimés.",
    "send": "{target} a été envoyé.",
    "create": "{target} a été créé.",
    "edit": "{target} a été traité avec succès.",
    "add": "{target} a été ajouté.",
    "deleteTeam": "L'utilisateur a été supprimé par l'équipe.",
    "setRole": "Le rôle de l'utilisateur a été défini avec succès",
    "joinLocation": "L'emplacement a été ajouté avec succès",
    "sendInvite": "L'e-mail d'invitation a été envoyé.",
    "sendTicket": "Nous avons bien reçu vos commentaires. Merci beaucoup.",
    "aiCall": "L'Octobot t'appellera sous peu."
  },
  "success.": "Action réussie",
  "alert": {
    "delete": {
      "account": "Souhaites-tu supprimer définitivement ton compte et tous les lieux qui y sont associés ?",
      "reminder": "Veux-tu vraiment supprimer ce réveil de commande ?",
      "location": "Veux-tu vraiment supprimer ce lieu ?",
      "list": "Veux-tu vraiment supprimer la liste \"{target}\" ?",
      "noList": "Tu veux supprimer tous les produits de ton panier ?",
      "cartSupplier": "Veux-tu vider ton panier à \"{target}\" ?",
      "cartProduct": "Veux-tu vraiment supprimer le produit \"{target}\" ; du panier ?",
      "cartList": "Veux-tu vraiment supprimer la liste \"{target}\" ; et tous les articles correspondants du panier ?",
      "product": "Veux-tu vraiment supprimer le produit \"{target}\" ; de la liste ? | Veux-tu vraiment supprimer les produits sélectionnés de la liste ?",
      "supplier": "Veux-tu supprimer {name} de tes fournisseurs ? Attention : en supprimant un fournisseur, on supprime également toutes les listes chez ce fournisseur.",
      "member": "Veux-tu vraiment supprimer \"{target}\" ; de ton équipe ?",
      "tag": "Veux-tu vraiment supprimer \"{target}\" ; de tes catégories ?",
      "customSupplier": "Tu veux vraiment supprimer ce fournisseur ?",
      "scanProduct": "Veux-tu vraiment supprimer le produit \"{target}\" ; de tes articles scannés ?"
    },
    "delivererSuccess": "Le fournisseur a été ajouté avec succès",
    "delivererError": "Erreur",
    "delivererSuccessMessage": "Nous avons ajouté {target} à ton emplacement.",
    "delivererErrorMessage": "{target} n'a pas pu être ajouté à votre localisation. Veuillez vérifier les données que vous avez saisies.",
    "selectList": "Choisis une liste",
    "selectSupplier": "Choisis un fournisseur",
    "noList": "Aucune liste n'est disponible pour ce fournisseur.",
    "noSupplier": "Aucun fournisseur disponible pour cet article",
    "discardFormTitle": "Attention !",
    "noInternet": "Toutes les données hors ligne n'ont pas pu être synchronisées. Veuillez vérifier votre connexion Internet.",
    "compatibilityMode": "Tu as activé le mode de compatibilité. Lorsque ce mode est activé, tu ne peux commander que via le portail web. La quantité que tu as indiquée se trouve maintenant dans ton panier. Si tu souhaites commander via l'application, désactive ce mode dans les paramètres de la liste.",
    "discardForm": "Vos données ne seront pas enregistrées. Quitter la page quand même ?",
    "syncing": "Les listes sont synchronisées",
    "logout": "Vous voulez vraiment vous désinscrire ?",
    "upgradeToPromotion": "Utiliser l'action maintenant ? La quantité est automatiquement ajustée à la quantité minimale ({target})",
    "convertToPromotion1": "Appliquer l'action ?",
    "convertToPromotion2": "{target1} Article en promotion, {target2} régulier",
    "orderAmountOverLimit": "Limite atteinte : {isAmount} Articles en promotion dans le panier. Max. +{availableAmount} possible",
    "scannerNotActivated": "La fonction scanner n'est actuellement pas supportée par tes fournisseurs !",
    "scannerAvailableOnlyInApp": "La fonction scanner n'est disponible que dans l'application !",
    "addLastOrderToCart": "Souhaites-tu rajouter dans ton panier tous les articles et toutes les quantités de ta dernière commande ?"
  },
  "titleRoute": {
    "locationData": "Créer un lieu",
    "locationCreate": "@:titleRoute.locationData",
    "locationDeliverer": "Choisir un fournisseur",
    "locationAdd": "Ajouter un lieu",
    "locationJoin": "Rejoindre un lieu",
    "addLocationDeliverer": "Ajouter un fournisseur",
    "editLocationDeliverer": "Modifier le fournisseur",
    "settingProfile": "Profil",
    "settingLocation": "Modifier le lieu",
    "settingOrder": "Commande | Commandes",
    "settingOrderDetail": "Détails de la commande",
    "settingTeam": "Équipe",
    "settingTeamInvite": "Inviter une équipe",
    "settingDeliverer": "Fournisseurs",
    "settingDelivererSelect": "Choisir un fournisseur",
    "settingNotification": "Notifications",
    "settingDisplay": "Options d'affichage",
    "settingSupport": "Assistance",
    "settingLegal": "Mentions légales",
    "cart": "Panier d'achat",
    "orders": "Commandes",
    "filter": "Filtre",
    "addList": "Créer une liste",
    "editList": "Modifier la liste",
    "notificationDetails": "@:titleRoute.settingNotification",
    "orderNotificationTimer": "Réveil de commande",
    "changePassword": "Modifier le mot de passe",
    "addProduct": "Ajouter un produit",
    "editProduct": "Modifier le produit",
    "agb": "Politique de confidentialité",
    "news": "Nouvelles d'Octopus",
    "suggestion": "Proposition de produit",
    "productDetails": "Détails du produit",
    "promotionDetails": "Détails de l'action",
    "productPresentation": "@:titleRoute.productDetails",
    "promotion": "@:titleRoute.promotionDetails",
    "settingIntro": "Apptour",
    "feedback": "Créer un feedback",
    "scanner": "Scanner",
    "skipEmail": "Vérification de l'email",
    "deleteLocations": "Lieux supprimés",
    "aiCall": "Commande d'IA"
  },
  "placeholder": {
    "search": "Recherche",
    "selectSize": "Sélectionner la taille",
    "selectVariant": "Sélectionner une variante",
    "location": {
      "name": "Nom de ton lieu",
      "type": "Type de lieu",
      "zip": "Code postal",
      "ownZip": "Code postal de votre propre lieu",
      "city": "Lieu",
      "street": "Rue",
      "streetNumber": "No.",
      "phone": "Numéro de téléphone",
      "internationalPhone": "Numéro de téléphone international",
      "deliverer": "Sélectionner @:object.deliverer",
      "customerNumber": "Saisir @:label.customerNumber"
    },
    "email": "Email",
    "newEmail": "Nouvel email",
    "oldPassword": "Ancien @:input.password",
    "password": "@:input.password",
    "passwordRepeat": "@:input.password répéter",
    "sendMessageDeliverer": "Envoyer un message à {deliverer} ...",
    "inviteCode": "Saisir le code d'invitation",
    "firstName": "@:label.firstName",
    "lastName": "@:label.lastName",
    "name": "Nom",
    "phone": "@:placeholder.location.phone",
    "street": "Rue",
    "zip": "CODE POSTAL",
    "city": "Lieu",
    "alphabetic": "Par ordre alphabétique",
    "customerNumber": "Numéro de client",
    "customerNumberPlus": "Numéro de client/numéro de site de vente",
    "quickstart": "Code de démarrage rapide",
    "paymentMethod": "Mode de paiement",
    "pickupMethod": "Lieu",
    "deliveryDate": "Date de livraison",
    "emailOrPhone": "@:placeholder.email",
    "code": "Code d'invitation",
    "packaging": "Taille de l'emballage",
    "searchOrAdd": "Chercher ou ajouter une catégorie",
    "tagName": "Nom de la catégorie",
    "pickupLocation": "Prise en charge à",
    "pickupDate": "Heure de collecte",
    "quantity": "Quantité",
    "eancode": "Code EAN",
    "customSupplierType": "Type de fournisseur",
    "issueType": "Type de feedback",
    "title": "Titre",
    "bug": {
      "issue": "Quel est le problème ?",
      "place": "Où se produit le problème ?",
      "expectation": "Quel comportement attendriez-vous au lieu du comportement actuel ?",
      "steps": "Quelles étapes ont été suivies avant que le bug ne se produise ? / Comment le bug peut-il être reproduit ?"
    },
    "feature": {
      "expectation": "Quelle fonction supplémentaire souhaiteriez-vous voir apparaître ?",
      "place": "Où la fonction souhaitée te manque-t-elle ?"
    },
    "select": "Sélectionner",
    "contactWay": "Comment pouvons-nous te contacter pour des questions ou des mises à jour ?"
  },
  "option": {
    "industry": {
      "PRIVATE": "Privé",
      "GETRAENKEFACHGROSSHANDEL": "Grossiste en boissons",
      "LEBENSMITTEL_GROSSHANDEL": "Alimentation en gros",
      "HANDELSWAREN_ALLGEMEIN": "Marchandises commerciales en général",
      "SONSTIGE": "Autres"
    },
    "customSupplierType": {
      "meat": "Fournisseur de viande",
      "vegetable": "Légumes",
      "drinks": "Boissons",
      "hygiene": "Articles d'hygiène",
      "other": "Autres"
    }
  }
}

export default fr;